export default "__VITE_ASSET__Bxmq4JdX__"